var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSidebarDrawerArrow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 13,
    viewBox: "0 0 7 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.7237 0.666873C5.99173 0.457108 6.26325 0.445168 6.53825 0.631051C6.81272 0.816288 6.94995 1.10254 6.94995 1.48979L6.94995 11.51C6.94995 11.8973 6.81272 12.1839 6.53825 12.3698C6.26325 12.555 5.99173 12.5427 5.7237 12.333L0.778464 7.32284C0.537233 7.12921 0.416617 6.8549 0.416617 6.49992C0.416617 6.14493 0.537233 5.87063 0.778464 5.677L5.7237 0.666873Z",
    fill: "#6E6E6E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarDrawerArrow);
export default __webpack_public_path__ + "static/media/sidebar-drawer-arrow.c06b4917b7fb9f873ead0e0d0445acbd.svg";
export { ForwardRef as ReactComponent };